import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';
import HintButton from './HintButton';

const mapPropsToState = (state) => ({
  isMobile: getIsMobile(state),
});

export default connect(mapPropsToState)(HintButton);
